import { liveMatches, categories } from '@/mocks/sportsData';

export default function LiveMatchSection() {
  const liveAndUpcoming = liveMatches.filter((m) => m.status === 'live' || m.status === 'upcoming');

  return (
    <section id="live" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-8 md:mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              赛事直播
            </h2>
            <p className="mt-2 text-sm text-foreground-500">实时比分 · 赛程预告</p>
          </div>
          <div className="flex items-center gap-2 flex-wrap">
            {categories.map((cat) => (
              <button
                key={cat.slug}
                className="px-3 py-1.5 rounded-full text-xs font-medium bg-secondary-100 text-secondary-700 hover:bg-secondary-200 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                {cat.name}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {liveAndUpcoming.slice(0, 6).map((match) => (
            <div
              key={match.id}
              className="group bg-background-50 border border-background-200/70 rounded-xl p-5 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="flex items-center justify-between mb-4">
                <span className="text-xs text-foreground-500">{match.league}</span>
                <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium ${
                  match.status === 'live'
                    ? 'bg-primary-100 text-primary-700'
                    : match.status === 'upcoming'
                      ? 'bg-accent-100 text-accent-800'
                      : 'bg-secondary-100 text-secondary-700'
                }`}>
                  {match.status === 'live' && (
                    <span className="w-1.5 h-1.5 rounded-full bg-primary-500 animate-pulse"></span>
                  )}
                  {match.statusText}
                </span>
              </div>

              <div className="flex items-center justify-between gap-3 mb-4">
                <div className="flex-1 text-center">
                  <p className="font-semibold text-foreground-900 text-sm md:text-base">{match.homeTeam}</p>
                </div>
                <div className="flex-shrink-0">
                  {match.status === 'live' ? (
                    <div className="flex items-center gap-2">
                      <span className="font-heading text-2xl font-bold text-primary-600">{match.homeScore}</span>
                      <span className="text-foreground-400 text-sm">:</span>
                      <span className="font-heading text-2xl font-bold text-primary-600">{match.awayScore}</span>
                    </div>
                  ) : (
                    <span className="text-foreground-400 text-xs">VS</span>
                  )}
                </div>
                <div className="flex-1 text-center">
                  <p className="font-semibold text-foreground-900 text-sm md:text-base">{match.awayTeam}</p>
                </div>
              </div>

              <div className="flex items-center justify-center">
                <span className="px-4 py-1.5 rounded-full bg-primary-500 text-background-50 text-xs font-medium whitespace-nowrap group-hover:bg-primary-600 transition-colors duration-200">
                  {match.status === 'live' ? '观看直播' : '预约提醒'}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}